<script setup>
import { toasts } from "../stores/toast.js";
</script>

<template>
  <div class="ds-toast-host">
    <p v-for="toast in toasts.items" :key="toast.id" :class="['toast', `toast-${toast.tone}`, 'show']">
      {{ toast.message }}
    </p>
  </div>
</template>
